
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's05b70c60d4ea8317': `Klepnite na „Otvoriť v prehliadači…“`,
's182ab2d6c997515f': `Pridajte ju na domovskú obrazovku pre rozšírené využitie a jednoduchý prístup.`,
's224cbcec014ef6b5': `Stlačte Zdieľať na navigačnom paneli`,
's233af3b7eb5e0364': `Pridať na domovskú stránku`,
's37a9e8aec5713460': `Viac`,
's4c3161035f3a1413': `Stlačte ponuku`,
's4e1e10a6ca408245': `Klepnite na "Pridať na domovskú obrazovku"`,
's6196153c4b0c1ea0': `Inštalovať`,
's633502f7cff4f847': `Otvorte ponuku prehliadača`,
's681e399d63311fba': `Zobraziť galériu`,
's6d14a4f70ba4e3cf': `Stlačte ponuku, ak nevidíte ikonu Zdieľať`,
's922329d6f6213590': `Pridať do Docku`,
's9c63a79ffcc2a3a3': `Stlačte "Pridať na domovskú obrazovku"`,
'sa2d71bfd9525168d': `Stlačte "Pridať do Docku"`,
'sa5ef80b4bb9b39f8': `Menej`,
'sb527eca1c1d7e7be': `Otvorte ponuku prehliadača v aplikácii`,
'sba52286c21552a4e': `Nainštalujte si ju na svoje zariadenie pre rozšírené využitie a jednoduchý prístup.`,
'sc16e00a7a8b2fde2': `Späť`,
'scdaf4bbff76674c8': `Pridať na domovskú obrazovku`,
'sd18a5b85f599ff3c': `Otvorte skopírovaný odkaz v Safari`,
'se72fc3a84f9b51c3': `Klepnutím skopírujete odkaz`,
'se740f75b95a51807': `Pridajte ju do Docku pre rozšírené využitie a jednoduchý prístup.`,
'sfa6c42cdf48d93d2': `Tento prehliadač však túto funkciu nepodporuje. Ak chcete pokračovať, otvorte odkaz v externom prehliadači.`,
'sfb78526365796a41': `Stlačte "Zobraziť viac" v ponuke Zdieľať`,
'sfea652f6580ff086': `Táto stránka má funkcie aplikácie.`,
    };
  